import InfoProfile from "./infoProfile/InfoProfile.vue";
import MyChallenge from "./myChallenge/MyChallenge.vue";
export default {
  InfoProfile,
  MyChallenge
}